export const validation_errors = {
  field: {
    start: 'Поле дата старта:',
    end: 'Поле дата окончания:',
    number: 'Поле номер:',
    status: 'Поле статус:',
    state: 'Поле статус:',
    name: 'Поле название:',
    login: 'Логин'
  },
  value: {
    'Peer already exists': 'уже существует',

    validation: {
      required: 'обязательно для заполнения',
      integer: 'должно быть числом',
      string: 'должно быть строкой'
    },
    'Date range must be less a month': 'Диапазон дат не должен превышать 1 месяц'
  },
  enter_date: 'Укажите даты'
};
